module.exports = __webpack_public_path__ + "static/media/whatisanemi.84a403a1.png";